<template>
  <div class="main">
    <FormWrapper :action="formAction" :method="formMethod">
      <div class="title-bar">
        <h1 class="mb-0">{{ download.id ? "Edit" : "Add New" }} Help Download</h1>
        <a class="btn-back" :href="route('admin.help.downloads.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div class="col-12 mb-3">
              <Field
                type="text"
                name="title"
                label="Title"
                :value="download.title"
                validate="required"
              />
            </div>
            <div class="col-12 mb-3 col-md-6 col-lg-4">
              <AssetField
                name="asset_id"
                label="Download File"
                validate="required"
                validate-as="download file"
                :value="download.asset_id"
              />
            </div>
            <div class="d-none d-md-flex col-md-6 col-lg-8"></div>
            <div class="col-12 mb-3">
              <Field
                type="checkbox"
                name="managers_only"
                id="managers_only"
                label="This download is available to Distributors Only"
                :value="!!download.managers_only"
                :checkbox-value="1"
              />
            </div>
            <div class="col-12">
              <hr />
              <h4 class="text-primary text-uppercase mb-4">Limit to Select Brands</h4>
            </div>
            <div class="col-12">
              <MultiAssignField
                type="select"
                name="brands"
                :value="download.brand_ids"
                :options="brands"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="text-center">
              <button type="submit" class="btn btn-success mr-2">Save Changes</button>
              <a class="btn btn-info" :href="route('admin.help.downloads.index')">Cancel & Exit</a>
            </div>
            <div v-if="download.id" class="font-size-sm text-center pt-4">
              <span>Last updated on {{ download.updated_at | moment("MM/DD/YYYY") }}</span>
              <span>at {{ download.updated_at | moment("h:mma") }}</span>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    download: { type: Object, required: true },
    brands: { type: Array, default: () => [] },
  },
  computed: {
    formAction() {
      return !this.download.id
        ? this.route("admin.help.downloads.store")
        : this.route("admin.help.downloads.update", {
            download: this.download.id,
          });
    },
    formMethod() {
      return !this.download.id ? "POST" : "PUT";
    },
  },
};
</script>